export enum DocumentationFiltersTypesMap {
  recordTypes = 'recordTypes',
  steps = 'steps',
  fieldTypes = 'fieldTypes',
  automationTypes = 'automationTypes',
  apexTypes = 'apexTypes',
  utilization = 'utilization',
  activeState = 'activeState',
  configurationType = 'configurationType',
  relatedObject = 'relatedObject',
  objectTypes = 'objectTypes',
  namespace = 'namespace',
  actionTypes = 'actionTypes',
  operations = 'operations',
  status = 'status',
}
export interface DocumentationValuedFilters {
  selectedValues: string[];
  stepsForSelectedRecordTypes?: string[];
}

export interface StepFilterItem {
  value: string;
  label: string;
  recordTypeId: string;
}

export interface RecordTypeFilterItem {
  value: string;
  label: string;
  steps: StepFilterItem[];
}
